import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { RxBrowserDetectionService } from '../rx-browser-detection.service';

@Injectable({
  providedIn: 'root',
})
export class RxIEActivateGuard implements CanActivate {
  constructor(
    private _browserDetection: RxBrowserDetectionService,
    private _router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    if (!this._browserDetection.isIE) {
      return true;
    }

    this._router.navigate(['/browser-notification']);
    return false;
  }
}
